<template>
  <img
    src="@/assets/task-handle-left.svg"
    alt=""
    draggable="false"
    class="handle-left"
    @click.stop
    @mousedown="$emit('mousedown', $event)"
  />
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.handle-left {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  user-select: none;
  transform: translateX(-100%);
}
</style>
